<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-text-field
        v-model="NameTH"
        v-bind:label="textLabelNameTh"
        v-bind:placeholder="textHintNameTh"
        v-bind:rules="nameThRules"
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field
        v-model="SurnameTH"
        v-bind:label="textLabelSurnameTh"
        v-bind:placeholder="textHintSurnameTh"
        v-bind:rules="nameThRules"
        outlined
        dense
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { objectTranslator } from "../../helper/translator";
import validator from "../../helper/validator";
export default {
  name: "nameThCard",
  props: [
    "value_nameTh",
    "value_surnameTh",
    "textLabelNameTh",
    "textPlaceholderNameTh",
    "textHintNameTh",
    "textLabelSurnameTh",
    "textPlaceholderSurnameTh",
    "textHintSurnameTh",
  ],

  data() {
    return {
      nameThRules: [validator.required],
    };
  },
  methods: {
    objectTranslator,
  },
  computed: {
    NameTH: {
      get() {
        return this.value_nameTh;
      },
      set(value) {
        this.$emit("input_nameTh", value);
      },
    },
    SurnameTH: {
      get() {
        return this.value_surnameTh;
      },
      set(value) {
        this.$emit("input_surnameTh", value);
      },
    },
  },
};
</script>
